
<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
<span *ngIf="$.row.balance_age_bucket;else empty">{{getData($.row.balance_age_bucket)}}
</span>
 <ng-template #empty>-</ng-template>
 </ng-container>